export enum SelectAllState {
  Selecting = 'selecting',
  Selected = 'selected',
  Deselected = 'deselected',
}
